import { Fragment, useMemo } from 'react'
import { FieldGroup } from '@/ui'
import { Controller, useFormContext } from 'react-hook-form'
import { Block, LoyaltyProgramBlockVariant } from '@/api/dashboard'
import { useTranslation } from 'react-i18next'
import { Select, SelectItem } from '@dashboard/ui'

interface LoyaltyProgramBlockEditorProps {
  allowed?: LoyaltyProgramBlockVariant[]
}

const LoyaltyProgramBlockEditor = ({
  allowed = [LoyaltyProgramBlockVariant.Standard, LoyaltyProgramBlockVariant.Expanded],
}: LoyaltyProgramBlockEditorProps) => {
  const { t } = useTranslation()
  const items = useMemo<SelectItem[]>(() => {
    const include = new Set(allowed)

    return [
      {
        value: LoyaltyProgramBlockVariant.Standard,
        children: t('hub-editor.loyalty-program.variant.standard.title'),
        caption: t('hub-editor.loyalty-program.variant.standard.caption'),
      },
      {
        value: LoyaltyProgramBlockVariant.Expanded,
        children: t('hub-editor.loyalty-program.variant.expanded.title'),
        caption: t('hub-editor.loyalty-program.variant.expanded.caption'),
      },
    ].filter(item => include.has(item.value))
  }, [allowed])

  const { control } = useFormContext<Block>()

  if (!items) {
    return <Fragment />
  }

  return (
    <FieldGroup label={t('hub-editor.loyalty-program.variant')}>
      <Controller
        name="variant"
        control={control}
        rules={{ required: t('validation.required') }}
        defaultValue={items[0].value as LoyaltyProgramBlockVariant}
        render={({ field }) => (
          <Select datatestid="hub-editor/loyalty-program" {...field} disabled={items.length <= 1} items={items} />
        )}
      />
    </FieldGroup>
  )
}

export default LoyaltyProgramBlockEditor
